<template>
  <router-view />
</template>

<script>
import "@/assets/css/fontawesome-all.min.css";
import "@/assets/css/fonts.css";
import "@/assets/css/styles.css";

// console.log('Am I the first one?')

export default {};
</script>
